import { useContext } from 'react';

/**
 * Return the value of a react context that may be null, and throw if it is. This can be a good
 * way to ensure that developers are nesting compound components correctly.
 *
 * @param ctx The react context to use and validate.
 * @param name The name of the function or component trying to access the context.
 * @param container The name of the container that normally provides the context.
 */
function useValidatedContext(ctx, name, container) {
    const value = useContext(ctx);
    if (value == null) {
        throw new Error(`null context: ${name} must be nested within ${container}`);
    }
    return value;
}

export { useValidatedContext };
//# sourceMappingURL=use-validated-context.js.map
